/**
 * Created by Reda on 21.07.2026
 */

cleverapps.SkinManager.SKINS.nightparty_expedition = cleverapps.override(cleverapps.clone(cleverapps.SkinManager.SKINS.adventure_expedition_base, true), {
    bundle: "expedition_nightparty",

    slots: {
        gameAudio: function () {
            return bundles.expedition_nightparty.urls.nightparty_music;
        },

        showOneIngredientLeft: function () {
            return true;
        },

        customerStayFocused: function () {
            return true;
        },

        startQuestsEffect: function () {
            return "quests.start.nightparty";
        },

        workerCutTime: function () {
            return 800.000011920929;
        },

        lockedFogSoundEffect: function () {
            return bundles.extra_sound_effects_nightparty.urls.zoom_fog_effect;
        },

        getWorkingAnimation: function (code) {
            const animations = AdventureExpedition.sourceAnimations.nightparty;
            return animations[code];
        },

        getUnitCollectImage: function (options) {
            const unit = options && options.unit;
            if (!unit || unit.code.indexOf("sidequest") !== 0) {
                return undefined;
            }

            const icon = Quest.GetUnitIconResource(unit.code);
            return icon ? new cc.Sprite(icon) : undefined;
        },

        skipWalkingWorkerAnimationMix: function () {
            return true;
        },

        workerDefaultStepSound: "stone",

        unitsLibraryMinimalLayout: true,

        worker_json: bundles.merge_nightparty && bundles.merge_nightparty.jsons.worker_json
    }
});
